/* eslint-disable camelcase */
import PropTypes from 'prop-types';

const propTypesSliceSimpleGrid = {
  simple_grid_slice_id: PropTypes.string,
};

const propTypesItemsSimpleGrid = {
  column_title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  headline_content: PropTypes.string,
  stars: PropTypes.string,
};

export const propTypesDataSimpleGrid = {
  id: PropTypes.string,
  slice_type: PropTypes.string,
  slice_label: PropTypes.string,
  primary: PropTypes.shape(propTypesSliceSimpleGrid),
  items: PropTypes.arrayOf(PropTypes.shape(propTypesItemsSimpleGrid)),
};
